export default "__VITE_ASSET__BqmteZLS__"